import Base from '@/models/base.model.js';
import Rates from './rates.model';
import Experience from './rates.model';

export class Professional extends Base {
	constructor(obj) {
		super(obj);
		if (!obj) return;

		this.name = obj.name;
		this.profession = obj.profession;
		this.contact = obj.contact;
		this.rates = new Rates(obj.rates);
		this.experience = new Experience(obj.experience);
		this.email = obj.email;
	}
}

export default Professional;
